import { createContext } from 'react';

export interface LoaderContextValue {
  isVisible: boolean;
  isProgress: boolean;
  progress: number;
  show: (options?: { progress?: boolean }) => void;
  hide: () => void;
  updateProgress: (value: number) => void;
}

export const LoaderContext = createContext<LoaderContextValue | null>(null);
